var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { getPropertyEntityRecords, getSponsors, } from "../../resources/helper/properties";
export var usePropertyEntitiesGetAll = function (trigger, entities, clientId) {
    var enable = useState(true)[0];
    var page = useState(1)[0];
    var limit = useState(100)[0];
    var _a = useState([]), responsePropertyEntities = _a[0], setResponsePropertyEntities = _a[1];
    var _b = useState(false), loadingPropertyEntities = _b[0], setLoadingPropertyEntities = _b[1];
    var _c = useState(null), errorPropertyEntities = _c[0], setErrorPropertyEntities = _c[1];
    var getEntities = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var needsSponsors, sponsorIds_1, sponsorResponse, error_1, results_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoadingPropertyEntities(true);
                    setErrorPropertyEntities(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 7, 8]);
                    needsSponsors = entities.some(function (entity) { return entity.filterBySponsor; });
                    sponsorIds_1 = [];
                    if (!needsSponsors) return [3 /*break*/, 5];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getSponsors()];
                case 3:
                    sponsorResponse = _b.sent();
                    sponsorIds_1 = ((_a = sponsorResponse === null || sponsorResponse === void 0 ? void 0 : sponsorResponse.data) !== null && _a !== void 0 ? _a : []).map(function (sponsor) { return sponsor.id; });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    setErrorPropertyEntities(error_1);
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, Promise.all(entities.map(function (entity) {
                        if (entity.filterBySponsor && sponsorIds_1.length === 0) {
                            return Promise.resolve([]);
                        }
                        return getPropertyEntityRecords(entity.url, entity.filterBySponsor ? undefined : enable, page, limit, entity.sendClientId ? clientId : undefined, entity.filterBySponsor ? sponsorIds_1 : undefined)
                            .then(function (response) { var _a; return ((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []); })
                            .catch(function (error) {
                            setErrorPropertyEntities(error);
                            return [];
                        });
                    }))];
                case 6:
                    results_1 = _b.sent();
                    setResponsePropertyEntities(entities.map(function (entity, index) { return ({
                        entityName: entity.entityName,
                        label: entity.label,
                        icon: entity.icon,
                        records: results_1[index],
                    }); }));
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingPropertyEntities(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [entities, clientId, enable, page, limit]);
    useEffect(function () {
        if (!trigger)
            return;
        getEntities();
    }, [trigger, getEntities]);
    return {
        responsePropertyEntities: responsePropertyEntities,
        errorPropertyEntities: errorPropertyEntities,
        loadingPropertyEntities: loadingPropertyEntities,
        getEntities: getEntities,
    };
};
